export const getResetTimeInfo = (): {
  resetTime: string;
} => {
  const now = new Date();
  const midnightUTC = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate() + 1,
      0,
      0,
      0,
      0
    )
  );
  // Format midnight UTC in user's local timezone
  const resetTime = midnightUTC.toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return { resetTime };
};

export const getMidnightUTC = () => {
  const now = new Date();
  const midnightUTC = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate() + 1,
      0, 0, 0, 0
    )
  );
  return midnightUTC.getTime() - now.getTime();
};